import axios from 'axios';
import ls from 'local-storage';

axios.defaults.headers = {
  'X-CAD-Access-Token': ls.get('token'),
};

export default axios;
